import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

/**
 * Shown inside AdminLayout when no child route matches (e.g. /admin/dashboard/unknown).
 */
export default function AdminNotFound() {
  const location = useLocation();

  useEffect(() => {
    const prev = document.title;
    document.title = "Page not found · VizHacks Admin";
    return () => {
      document.title = prev;
    };
  }, []);

  return (
    <div className="admin-dash__page admin-dash__page--detail">
      <header className="admin-dash__page-head">
        <div>
          <p className="admin-dash__page-eyebrow">404</p>
          <h1 className="admin-dash__overview-title">Page not found</h1>
          <p className="admin-dash__overview-lede" style={{ maxWidth: 520 }}>
            This URL is not part of the admin dashboard. Check the path or return to the overview.
          </p>
        </div>
      </header>
      <section className="admin-dash__panel admin-dash__panel--soft">
        <p className="admin-dash__panel-sub" style={{ marginBottom: 16 }}>
          <code className="admin-dash__code-inline">{location.pathname}</code>
        </p>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
          <Link className="admin-dash__btn-primary" to="/admin/dashboard">
            Dashboard overview
          </Link>
          <Link className="admin-dash__btn-secondary" to="/admin/dashboard/requests">
            Service requests
          </Link>
        </div>
      </section>
    </div>
  );
}
